export const TRANSFER_ITEMS_PER_PAGE = 20;
export const STORAGE_KEY_TRANSFER_FILTERS = 'transfer_management_filters';
export const TRANSFER_BASE_PATH = '/api/v1/transfer';
